import ScreenRenderer from './ScreenRenderer'
export default ScreenRenderer


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/index.js